export default __webpack_public_path__ + "static/media/factor.13380b70.svg";